import { ReactElement } from 'react';

import { useTheme } from '../../../../theme/useTheme';

export const SendToEmailIcon = ({ className }: { className: string }): ReactElement => {
	const theme = useTheme();
	const { fill, width, height } = theme.chat.header.select.sendToEmailIcon;
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.2929 15.2929C18.6834 14.9024 19.3166 14.9024 19.7071 15.2929L21.7071 17.2929C22.0976 17.6834 22.0976 18.3166 21.7071 18.7071C21.3166 19.0976 20.6834 19.0976 20.2929 18.7071L20 18.4142V22C20 22.5523 19.5523 23 19 23C18.4477 23 18 22.5523 18 22V18.4142L17.7071 18.7071C17.3166 19.0976 16.6834 19.0976 16.2929 18.7071C15.9024 18.3166 15.9024 17.6834 16.2929 17.2929L18.2929 15.2929Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.17548 8.43441C6.4879 7.97898 7.11036 7.86305 7.56578 8.17548L11.4344 10.8293C11.7753 11.0632 12.2249 11.0632 12.5658 10.8294L16.4344 8.17548C16.8898 7.86305 17.5123 7.97898 17.8247 8.43441C18.1371 8.88983 18.0212 9.51229 17.5658 9.82471L13.6972 12.4786C12.6745 13.1801 11.3257 13.1801 10.303 12.4786L6.43441 9.82471C5.97898 9.51229 5.86305 8.88983 6.17548 8.43441Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.7587 4H16.2413C17.0463 3.99999 17.7106 3.99998 18.2518 4.04419C18.8139 4.09012 19.3306 4.18868 19.816 4.43597C20.5686 4.81947 21.1805 5.43139 21.564 6.18404C21.8113 6.66937 21.9099 7.18608 21.9558 7.74817C22 8.28936 22 8.95372 22 9.75868V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V9.8C20 8.94342 19.9992 8.36113 19.9624 7.91104C19.9266 7.47262 19.8617 7.24842 19.782 7.09202C19.5903 6.7157 19.2843 6.40973 18.908 6.21799C18.7516 6.1383 18.5274 6.07337 18.089 6.03755C17.6389 6.00078 17.0566 6 16.2 6H7.8C6.94342 6 6.36113 6.00078 5.91104 6.03755C5.47262 6.07337 5.24842 6.1383 5.09202 6.21799C4.7157 6.40973 4.40973 6.7157 4.21799 7.09202C4.1383 7.24842 4.07337 7.47262 4.03755 7.91104C4.00078 8.36113 4 8.94342 4 9.8V14.2C4 15.0566 4.00078 15.6389 4.03755 16.089C4.07337 16.5274 4.1383 16.7516 4.21799 16.908C4.40973 17.2843 4.7157 17.5903 5.09202 17.782C5.24842 17.8617 5.47262 17.9266 5.91104 17.9624C6.36113 17.9992 6.94342 18 7.8 18H13C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H7.75873C6.95374 20 6.28938 20 5.74817 19.9558C5.18608 19.9099 4.66937 19.8113 4.18404 19.564C3.43139 19.1805 2.81947 18.5686 2.43597 17.816C2.18868 17.3306 2.09012 16.8139 2.04419 16.2518C1.99998 15.7106 1.99999 15.0463 2 14.2413V9.7587C1.99999 8.95373 1.99998 8.28937 2.04419 7.74818C2.09012 7.18608 2.18868 6.66937 2.43597 6.18404C2.81947 5.43139 3.43139 4.81947 4.18404 4.43597C4.66937 4.18868 5.18608 4.09012 5.74817 4.04419C6.28937 3.99998 6.95373 3.99999 7.7587 4Z"
				fill={fill}
			/>
		</svg>
	);
};
